export default (context) => {
  return {
    config: {
      pageSize: 0,
      hiddenGrid: true
    },

    actions: {
    },

    extras:{
      forms: [
        {
          type: 'sideToSide',
          configLeft: {
            GET: 'admStudent/get/',
            POST: 'admSection/moveStudents ',
            title: 'Lista Actual',
            search: true,
            fields: [
              {
                col: 12,
                name: "active",
                value: 1,
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "enrolled",
                value: -1,
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "statuses",
                value: "10|11|12",
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "superSectionId",
                value: null,
                type: "select",
                label: "Grado",
                opts: {
                  style: 'float-label',
                  path: "/admSuperSection/get?pick=true",
                  setOutput: v => v
                }
              },
              {
                col: 12,
                name: "sectionId",
                value: "",
                type: "select",
                label: "Sección",
                parent: 'superSectionId',
                opts: {
                  style: 'float-label',
                  path: (ctx) => { return "/admSection/get?pick=true&parentId=" + ctx.state.superSectionId.value },
                  setOutput: v => v
                },
                renderIf: (ctx) => { return  ctx.state.superSectionId }
              },
            ],
            columns: [
              {
                Header: "Alumno",
                accessor: "name"
              },
              {
                Header: "Grado / sección",
                accessor: "sectionTag"
              }
            ]
          },
          configRight: {
            GET: 'admStudent/get/',
            POST: 'admSection/moveStudents',
            title: 'Lista de Nueva Sección',
            search: true,
            fields: [
              {
                col: 12,
                name: "active",
                value: 1,
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "enrolled",
                value: -1,
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "statuses",
                value: "10|11|12",
                type: "hidden",
                label: "",
              },
              {
                col: 12,
                name: "superSectionId",
                value: null,
                type: "select",
                label: "Grado",
                opts: {
                  style: 'float-label',
                  path: "/admSuperSection/get?pick=true",
                  setOutput: v => v
                }
              },
              {
                col: 12,
                name: "sectionId",
                value: "",
                type: "select",
                label: "Sección",
                parent: 'superSectionId',
                opts: {
                  style: 'float-label',
                  path: (ctx) => { return "/admSection/get?pick=true&parentId=" + ctx.state.superSectionId.value },
                  setOutput: v => v
                },
                renderIf: (ctx) => { return  ctx.state.superSectionId }
              },
            ],
            columns: [
              {
                Header: "Alumno",
                accessor: "name"
              },
              {
                Header: "Grado / sección",
                accessor: "sectionTag"
              }
            ]
          }
        }
      ]
    },

    columns: []
  }
}